"use strict";

require("core-js/modules/es6.function.name");

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  transition: all 0.2s ease-in-out;\n  font-size: ", "px;\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  left: 20px;\n  position: absolute;\n  top: 13px;\n  transition: all 0.2s ease-in-out;\n  pointer-events: none;\n  transform: translate3d(0,0,0);\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _box = _interopRequireDefault(require("@waglabs/box"));

var _label = _interopRequireDefault(require("@waglabs/label"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var LabelContainer = (0, _styledComponents.default)(_box.default)(_templateObject(), function (props) {
  return props.isFocused && "\n    left: 10px;\n    top: 0;\n  ";
});
var TextInputLabel = (0, _styledComponents.default)(_label.default)(_templateObject2(), function (props) {
  return props.theme.fontSizes[4] || 18;
}, function (props) {
  return props.isFocused && "\n    font-size: " + (props.theme.fontSizes[2] || 12) + "px\n  ";
});

var AnimatedInputLabel = function AnimatedInputLabel(_ref) {
  var children = _ref.children,
      isFocused = _ref.isFocused,
      name = _ref.name;
  return _react.default.createElement(LabelContainer, {
    isFocused: isFocused
  }, _react.default.createElement(TextInputLabel, {
    color: "wagGray",
    fontFamily: "body",
    fontSize: 2,
    htmlFor: name,
    isFocused: isFocused
  }, children));
};

var _default = AnimatedInputLabel;
exports.default = _default;